import React from 'react';
import { Breadcrumbs } from '@/components';
// import { useTasksQuery } from '@/store/services/QuestApi.service';
import { useTranslation } from 'react-i18next';
import { TaskList } from './task-list';
// import { WhitelistRewards } from './whitelist-daily-reward';
import { connect } from 'react-redux';
import { RootState } from '@/store';
import { selectUserProfile } from '@/store/features';

const MIDLE_CUSTOMER_ID = '63aad3d7a554b70a4f20ffcc';

function TasksView() {
  const { t } = useTranslation();

  return (
    <div className='quests max-w-7xl px-4 py-8 mx-auto space-y-4 xl:space-y-6'>
      <Breadcrumbs paths={[{ text: t('Tasks'), href: '/tasks' }]} />

      <div className='space-y-4 xl:space-y-6'>
        <TaskList
          title={t('Main Task')}
          type='main'
          customer={MIDLE_CUSTOMER_ID}
          showViewAll={false}
          defaultPlatform={''}
          // showStatusFilters
          showOtherFilters
        />

        <TaskList
          title={t('Hot')}
          type='left'
          hideCustomer={MIDLE_CUSTOMER_ID}
          showViewAll={false}
          defaultPlatform={''}
          // showStatusFilters
          showOtherFilters
        />
        <TaskList
          title={t('Max Points')}
          type='right'
          hideCustomer={MIDLE_CUSTOMER_ID}
          showViewAll={false}
          defaultPlatform={''}
          // showStatusFilters
          showOtherFilters
        />

        {/*<WhitelistRewards />*/}
      </div>
    </div>
  );
}

export default connect((state: RootState) => ({
  userProfile: selectUserProfile(state),
}))(TasksView);
